module.exports = __webpack_public_path__ + "static/img/backgroundNation.a2760944.jpg";